<template>
  <div class="payment-methods">
    <VLazyImage class="payment-methods__label" alt="Site seguro" :src="icons.safeSite" width="138" height="28" />
    <VLazyImage class="payment-methods__label" alt="Pague com Visa" :src="icons.visa" width="46" height="28" />
    <VLazyImage class="payment-methods__label" alt="Pague com Master" :src="icons.master" width="46" height="28" />
    <VLazyImage class="payment-methods__label" alt="Pague com American Express" :src="icons.amex" width="46" height="28" />
    <VLazyImage class="payment-methods__label" alt="Pague com Elo" :src="icons.elo" width="46" height="28" />
    <VLazyImage class="payment-methods__label" alt="Pague com Boleto" :src="icons.boleto" width="46" height="28" />
  </div>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'

  .payment-methods
    padding: 20px 0px
    text-align: center

    @media (min-width: $screen-md-min)
      text-align: left

    @media (min-width: $screen-lg-min)
      padding: 0
      text-align: center

  .payment-methods__label
    height: 21px
    margin-left: 3px

    @media (min-width: $screen-sm-min)
      height: 23px

    @media (min-width: $screen-lg-min)
      height: 28px


</style>

<script>
  import VLazyImage from "v-lazy-image";

  import safeSite from '~/assets/images/icons/payments/trusted@2x.png';
  import visa from '~/assets/images/icons/payments/visa@2x.png';
  import master from '~/assets/images/icons/payments/master@2x.png';
  import amex from '~/assets/images/icons/payments/amex@2x.png';
  import elo from '~/assets/images/icons/payments/elo@2x.png';
  import boleto from '~/assets/images/icons/payments/boleto@2x.png';

  export default {
    data() {
      return {
        icons: {
          safeSite,
          visa,
          master,
          amex,
          elo,
          boleto,
        },
      };
    },
    components: {
      VLazyImage,
    },
  };
</script>
